import { CancelTokenSource } from "axios";
import { GetterTree } from "vuex";
import { DataSourceResult } from "@/models/DataSourceResult";
import { FilterCollection } from "@/models/FilterCollection";
import { GridColumn } from "@/models/GridColumn";
import { MultiselectItem } from "@/models/MultiselectItem";
import { TableSettings } from "@/models/TableSettings";
import { CampaignEditViewModel, CampaignsPageViewModel } from "@/models/campaigns/Campaign";
import { CampaignGridView, RefreshGridMode } from "@/models/campaigns/CampaignGridView";
import { CampaignsStatisticsByDate } from "@/models/campaigns/CampaignsStatisticsByDate";
import { CampaignStatus } from "@/models/campaigns/CampaignStatus";
import { CreatePhoneViewModel } from "@/models/phones/CreatePhoneViewModel";
import { CampaignsState } from "@/models/states/CampaignsState";
import { RootState } from "@/models/states/RootState";
import { CampaignsPayload } from "@/services/api/CampaignsApiService";

const getters: GetterTree<CampaignsState, RootState> = {

  campaignEditSelectedProjectsIds(state): number[] {
    return state.campaignEditSelectedProjectsIds;
  },

  campaignEditSelectedTagsIds(state): number[] {
    return state.campaignEditSelectedTagsIds;
  },

  campaignEditViewModel(state): CampaignEditViewModel | undefined {
    return state.campaignEditViewModel;
  },

  campaigns(state): DataSourceResult {
    return state.campaigns;
  },

  campaignsCancelTokenSource(state): CancelTokenSource | undefined {
    return state.campaignsCancelTokenSource;
  },

  campaignsLoading(state): boolean {
    return state.campaignsLoading;
  },

  campaignsPageData(state): CampaignsPageViewModel | undefined {
    return state.campaignsPageData;
  },

  campaignsPayload(state): CampaignsPayload | undefined {
    return state.campaignsPayload;
  },

  campaignsStatsByDate(state): CampaignsStatisticsByDate[] | null | undefined {
    return state.campaignsStatsByDate;
  },

  campaignsWithStats(state): CampaignGridView[] | null | undefined {
    return state.campaignsWithStats;
  },

  companies(state): MultiselectItem[] {
    return state.companies;
  },

  columns(state): GridColumn[] {
    return state.columns;
  },

  columnsFilters(state): FilterCollection | undefined {
    return state.columnsFilters;
  },

  createPhoneViewModel(state): CreatePhoneViewModel | undefined {
    return state.createPhoneViewModel;
  },

  datePeriod(state): Date[] {
    return state.datePeriod;
  },

  graphsHiddenOnScroll(state): boolean {
    return state.graphsHiddenOnScroll;
  },

  isMediaChannel(state): boolean {
    return state.isMediaChannel;
  },

  needToRefreshCampaignsGrid(state): RefreshGridMode {
    return state.needToRefreshCampaignsGrid;
  },

  page(state): number {
    return state.page;
  },

  projects(state): MultiselectItem[] {
    return state.projects;
  },

  searchValue(state): string {
    return state.searchValue;
  },

  selectedCampaign(state): CampaignGridView | undefined {
    return state.selectedCampaign;
  },

  selectedCampaignsIds(state): number[] {
    return state.selectedCampaignsIds;
  },

  selectedCampaignStatus(state): CampaignStatus | null | undefined {
    return state.selectedCampaignStatus;
  },

  selectedChannelMetadataTypesIds(state): number[] {
    return state.selectedChannelMetadataTypesIds;
  },

  selectedCompaniesIds(state): number[] {
    return state.selectedCompaniesIds;
  },

  selectedCampaignGridColumnsIds(state): number[] {
    return state.selectedCampaignGridColumnsIds;
  },

  selectedProjectsIds(state): number[] {
    return state.selectedProjectsIds;
  },

  showGraphs(state): boolean {
    return state.showGraphs;
  },

  sortDir(state): string {
    return state.sortDir;
  },

  sortField(state): string {
    return state.sortField;
  },

  tableSettings(state): TableSettings[] | undefined {
    return state.tableSettings;
  },
};
export default getters;
